/** Main project script */
'use strict';

import {createApp} from 'vue';
import {Collapse, Lightbox, initTE} from "tw-elements";
import SuggestiveSearch from './components/suggestive-search';
import MapBox from './components/map-box';
import MultiMapBox from './components/multi-map-box';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import {ApolloClient, createHttpLink, InMemoryCache} from '@apollo/client/core';
import { EventBus } from './event-bus.js';

var link = window.solout.baseUrl.split('/');
link.push('graphql');
link = link.filter(function (el) {
    if (el === null || el === undefined || el === "" || !el || el === " ") {
        return false;
    }
    return true;
});

link = '/' + link.join('/');

// HTTP connection to the API
const httpLink = createHttpLink({
    // You should use an absolute URL here
    uri: link,
});

// Cache implementation
const cache = new InMemoryCache();

// Create the apollo client
const apolloClient = new ApolloClient({
    link: httpLink,
    cache,
});

import {createApolloProvider} from '@vue/apollo-option'

const apolloProvider = createApolloProvider({
    defaultClient: apolloClient,
})

//  end graphql

const app = createApp({
    components: {
        SuggestiveSearch,
        MapBox,
        MultiMapBox,
    },
    // Shared app state
    data() {
        return {
            navigation: {
                open: false,
                openSubMenu: 0,
                mobileMenuOpen: false,
                mobileMenuSubMenu: 0,
                searchBarOpen: false
            },
            minPageHeight: null,
            scrolled: false,
            focus: null,
        };
    },
    methods: {
        handleScroll: function () {
            if (window.scrollY > 44) {
                // The screen is scrolled down more than 44 pixels from the top
                this.scrolled = true;
            } else {
                // The screen is at the top or close to it
                this.scrolled = false;
            }
        },
        fixSearchBar: function (action) {
            if (action === 'open') {
                this.navigation.searchBarOpen = true;
            } else {
                this.navigation.searchBarOpen = false;
            }
        },
        toggleSearchBar: function () {
            this.navigation.mobileMenuOpen = false;
            this.navigation.searchBarOpen = !this.navigation.searchBarOpen;
        },
        toggleSubmenu: function (id) {
            if (this.navigation.openSubMenu === id) {
                this.navigation.openSubMenu = 0;
            } else {
                this.navigation.openSubMenu = id;
            }
        },
        fixMobileMenu: function (action) {
            if (action === 'open') {
                this.navigation.mobileMenuOpen = true;
            } else {
                this.navigation.mobileMenuOpen = false;
            }
        },
        toggleMobileMenu: function (id) {
            this.navigation.mobileMenuOpen = !this.navigation.mobileMenuOpen;

            const body = document.querySelector('.main-layout');
            const footer = document.querySelector('footer');
            const searchSection = document.querySelector('.header-search-section');
            if (this.navigation.mobileMenuOpen) {
                document.querySelector('#sub-menu-0').classList.remove('opacity-0');
                setTimeout(() => {
                    body.classList.add('hidden');
                    footer.classList.add('hidden');
                    searchSection.classList.add('lg:fixed-search');
                }, 500);
            } else {
                body.classList.remove('hidden');
                footer.classList.remove('hidden');
                searchSection.classList.remove('lg:fixed-search');
            }
        },
        toggleMobileSubmenu: function (id) {
            // if (this.navigation.mobileMenuSubMenu === id) {
            //     this.navigation.mobileMenuSubMenu = 0;
            // } else {
                this.navigation.mobileMenuSubMenu = id;
            // }

            const parentMenu = document.querySelector('#sub-menu-' + id)
            setTimeout(() => {
                parentMenu.classList.remove('opacity-0');
            }, 100);
        },
        goTo: function (url) {
            window.location.href = url;
        },
        setupScrollHelper: function () {
            let targets = document.querySelectorAll('[data-scrollhelper]');
            // loop through the targets
            const options = {
                root: null,
                threshold: 0.2
            };

            for (let i = 0; i < targets.length; i++) {
                let preset = targets[0].dataset?.presetClass?.trim().split(' ');
                let parent = targets[0].closest('section');
                parent.classList.add('animation-parent');
                if (preset) {
                    preset.forEach(value => targets[i].classList.add(value));
                    // targets[0].classList.add(preset.join[',']);
                }
            }

            const observer = new IntersectionObserver(function (entries, observer) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // process:
                        let me = entry.target;

                        let cssClass = me.dataset?.class?.trim().split(' ');

                        if (cssClass) {
                            cssClass.forEach(value => me.classList.add(value));
                            // me.classList.add(cssClass);
                        }

                        me.classList.add("appear-on-scroll");
                        observer.unobserve(me);
                    } else {
                        return;
                    }
                });
            }, options);

            targets.forEach(target => observer.observe(target));
        },
        scrollHelper: function (el, elClass, offset, callback) {
        },
        toggleParentClass: function (parentSelector, className, method) {
            if (method === 'add') {
                document.querySelector(parentSelector).classList.add(className);
            } else {
                document.querySelector(parentSelector).classList.remove(className);
            }
        },
        toggleLocation: function (wrapperID, direction) {
            const wrapper = document.querySelector('#locations-wrapper-' + wrapperID);
            const slides = wrapper.querySelectorAll('.location-content');
            const currentSlide = wrapper.querySelector('.location-content.active');

            const total = slides.length;
            const currentPos = Array.from(slides).indexOf(currentSlide);
            let newPos = null;

            if (direction === 'right') {
                newPos = currentPos + 1;
                if (newPos === total) {
                    newPos = 0;
                }
            } else {
                newPos = currentPos - 1;
                if (newPos < 0) {
                    newPos = total - 1;
                }
            }

            const map = wrapper.parentElement.parentElement.querySelector('.open-street-map');

            this.transitionLocation(slides[currentPos], slides[newPos]);
            this.toggleLocationPin(map, currentPos, newPos);
            EventBus.emit('reset-map', wrapperID);
        },
        transitionLocation: function (currentSlide, newSlide) {
            currentSlide.classList.remove('active');
            newSlide.classList.add('active');

            currentSlide.classList.remove('opacity-100');
            currentSlide.classList.add('opacity-0');

            setTimeout(() => {
                currentSlide.classList.add('hidden');

                newSlide.classList.add('opacity-0');
                newSlide.classList.remove('hidden');
            }, 300);

            setTimeout(() => {
                newSlide.classList.remove('opacity-0');
                newSlide.classList.add('opacity-100');
            }, 400);
        },
        toggleLocationPin: function (map, currentPos, newPos) {
            const currentPin = map.querySelector('svg > g#icon-' + currentPos + ' > path');
            const newPin = map.querySelector('svg > g#icon-' + newPos + ' > path');

            currentPin.style.fill = '#0c6cb6';
            newPin.style.fill = '#92342f';
        },
        configureCarousels: function () {
            const carousels = document.querySelectorAll('.carousel');
            carousels.forEach(function(carousel) {
                // configure breakpoints and config for each carousel type
                let breakpoints = {};
                let spaceBetween = 30;
                let pagination = false;

                const slideCount = carousel.querySelectorAll('.swiper-slide').length;

                if (carousel.classList.contains('quote-carousel')) {
                    breakpoints = {
                        '576': {
                            slidesPerView: slideCount > 2 ? 2 : slideCount
                        },
                        '768': {
                            slidesPerView: slideCount > 3 ? 3 : slideCount
                        }
                    }
                    
                    pagination = {
                        el: '#' + carousel.id + '-pagination',
                    };

                    carousel.querySelectorAll('span.toggle-quote').forEach(function (button) {
                        button.addEventListener('click', function (e) {
                            const extendedText = button.parentElement.querySelector('span.hidden');
                            extendedText.classList.remove('hidden');
                            button.remove();
                        });
                    });
                } else if (carousel.classList.contains('gallery-carousel')) {
                    breakpoints = {
                        '576': {
                            slidesPerView: slideCount > 2 ? 2 : slideCount
                        },
                        '768': {
                            slidesPerView: slideCount > 3 ? 3 : slideCount
                        },
                        '1200': {
                            slidesPerView: slideCount > 4 ? 4 : slideCount
                        }
                    };
                } else {
                    breakpoints = {
                        '992': {
                            slidesPerView: slideCount > 2 ? 2 : slideCount
                        },
                        '1400': {
                            slidesPerView: slideCount > 3 ? 3 : slideCount
                        }
                    };
                    spaceBetween = 16;
                }

                // initialize swiper
                // eslint-disable-next-line no-unused-vars
                const swiper = new Swiper('.' + carousel.id, {
                    direction: 'horizontal',
                    keyboard: {
                        enabled: true,
                        onlyInViewport: false,
                    },
                    navigation: {
                        nextEl: '#' + carousel.id + '-right',
                        prevEl: '#' + carousel.id + '-left',
                    },
                    pagination: pagination,
                    slidesPerView: 1,
                    spaceBetween: spaceBetween,
                    breakpoints: slideCount > 1 ? breakpoints : null,
                    watchSlidesProgress: true,
                });
            });        
        },
        activateLightbox: function () {
            const root = this;

            const openLightboxes = document.querySelectorAll('.activate-lightbox');
            openLightboxes.forEach(function (opener) {
                opener.addEventListener('click', function (e) {
                    root.openLightbox(opener);
                });

                opener.addEventListener('keypress', function (e) {
                    if (e.key === "Enter") {
                        root.openLightbox(opener);
                    }
                });
            });

            const closeLightboxes = document.querySelectorAll('.close-lightbox');
            closeLightboxes.forEach(function (closer) {
                closer.addEventListener('click', function (e) {
                    root.closeLightbox();
                });
            });
        },
        openLightbox: function (item) {
            this.focus = item;

            const lightbox = document.querySelector('#lightbox');
            const id = item.dataset.id;
            const selectedLightbox = document.querySelector('#lightbox-' + id);
            const content = selectedLightbox.innerHTML;

            lightbox.querySelector('#lightbox-content').innerHTML = content;
            lightbox.classList.remove('hidden');
            lightbox.removeAttribute('inert');

            document.querySelector('header').setAttribute('inert', '');
            document.querySelector('body').style.overflow = 'hidden';
            document.querySelector('#main-layout').setAttribute('inert', '');
            document.querySelector('footer').setAttribute('inert', '');

            document.querySelectorAll('table').forEach(function (table) {
                table.classList.add('overflow-hidden');
            });

            // allow use of hidden while also allowing transition
            setTimeout(function () {
                lightbox.classList.remove('opacity-0');
            }, 100);
        },
        closeLightbox: function () {
            const lightbox = document.querySelector('#lightbox');
            lightbox.classList.add('opacity-0');
            lightbox.setAttribute('inert', '');

            lightbox.querySelector('#lightbox-content').innerHTML = '<div></div>';

            document.querySelector('header').removeAttribute('inert');
            document.querySelector('body').style.overflow = 'visible';
            document.querySelector('#main-layout').removeAttribute('inert');
            document.querySelector('footer').removeAttribute('inert');

            document.querySelectorAll('table').forEach(function (table) {
                table.classList.remove('overflow-hidden');
            });

            setTimeout(function () {
                lightbox.classList.add('hidden');
            }, 400);

            this.focus.focus();
        },
        configureYoutubeVideo: function () {
            // Grab the prefers reduced media query.
            const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

            // Check if the media query matches or is not available.
            if (!mediaQuery || mediaQuery.matches) {
                // Do nothing
            } else {
                let player;
                const video = document.querySelector('#player');
                if (!video) {
                    return;
                }
                
                const videoID = video.dataset.videoid;
                const bannerVideo = document.querySelector('#banner-video');
                const bannerImage = document.querySelector('#banner-image');

                function vidRescale() {
                    let w = window.innerWidth;
                    let h = window.innerHeight + 200;
                    let videoRatio = 16/9;
                    let windowRatio = w/h;

                    if (windowRatio > videoRatio) {
                        player.setSize(w, w/videoRatio);
                    } else {
                        player.setSize(h*videoRatio, h);
                    }
                }

                window.onresize = vidRescale;

                function onPlayerReady(event) {
                    event.target.mute();
                    event.target.setPlaybackQuality('hd720');
                    vidRescale();
                }

                function onPlayerStateChange(event) {
                    const playerState = event.data;

                    if (playerState == -1) {
                        bannerImage.classList.remove('hidden');
                        bannerVideo.classList.add('hidden');
                    } else if (playerState == YT.PlayerState.PLAYING) {
                        window.setTimeout(function () {
                            bannerImage.classList.add('hidden');
                            bannerVideo.classList.remove('hidden');
                        }, 300);
                    }

                    if (playerState == YT.PlayerState.BUFFERING) {
                        event.target.setPlaybackQuality('hd720');
                    }

                    if (playerState == YT.PlayerState.ENDED) {
                        player.playVideo();
                    }
                }

                function onYouTubeIframeAPIReady() {
                    const playerDefaults = {
                        'playsinline': 1,
                        'autoplay': 1,
                        'controls': 0,
                        'disablekb': 1,
                        'enablejsapi': 1,
                        'loop': 1,
                        'showinfo': 0,
                        // 'modestbranding': 1,
                        'fs': 0,
                        'cc_load_policy': 0,
                        'iv_load_policy': 3,
                        'listType': 'playlist',
                        'playlist': videoID,
                        'rel': 0,
                        'origin': window.location.origin,
                        'widget_referrer': window.location.origin
                    };

                    player = new YT.Player('player', {
                        videoId: videoID,
                        playerVars: playerDefaults,
                        events: {
                            'onReady': onPlayerReady,
                            'onStateChange': onPlayerStateChange
                        }
                    });
                }

                // Load the YouTube API script
                const tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                tag.setAttribute('allow', 'postMessage');
                const firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
            }
        },
        initCustomScripts: function () {
            const scriptSections = document.querySelectorAll('.custom-script');
    
            scriptSections.forEach(function (section) {
                const customScript = section.querySelector('div');
                if (customScript) {
                    // loop through every attribute and add it to the script
                    const attributes = customScript.attributes;
                    let script = document.createElement('script');
    
                    for (let i = 0; i < attributes.length; i++) {
                        script.setAttribute(attributes[i].name, attributes[i].value);
                    }

                    try {
                        document.body.appendChild(script);
                        console.log('Appended script ' + script.src);
                    } catch (e) {
                        console.error('Error appending script: ', e);
                    }
                }
            });
        },
    },
    created() {
        // this.handleDebouncedScroll = debounce(this.handleScroll, 100);
        // window.addEventListener('scroll', this.handleScroll);
    },
    mounted() {
        this.setupScrollHelper();
        initTE({Collapse, Lightbox});
        this.handleScroll();
        window.addEventListener('scroll', this.handleScroll);

        this.configureCarousels();
        this.configureYoutubeVideo();
        this.activateLightbox();
        this.initCustomScripts();

        // on esc key
        window.addEventListener('keyup', function (e) {
            if (e.key === "Escape") {
                const lightbox = document.querySelector('#lightbox');
                if (!lightbox.classList.contains('hidden')) {
                    this.closeLightbox();
                }
            }
        });
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    }
});

app.config.globalProperties.location = window.location;
app.use(apolloProvider);
app.mount('#tw_app');
